import { Component, Inject, ViewContainerRef, OnInit, Compiler } from '@angular/core';
import { DomService } from '@app/shared';
import { ConfirmationService, LoadingComponent } from '@app/library';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  initialLoad: any = false;

  constructor(
    @Inject(ConfirmationService) service,
    @Inject(ViewContainerRef) viewContainerRef,
    private dom: DomService,
    private router: Router,
    private _compiler: Compiler
  ) {
    service.setRootViewContainerRef(viewContainerRef);
    this.dom.appendComponentToBody(LoadingComponent);
    this._compiler.clearCache();
  }

  ngOnInit() {
    // this.router.events.subscribe((event: any) => {       
    //   if (event instanceof NavigationStart) {
    //     //Show loading indicator
    //    if (this.initialLoad) {//this is used to clear primeng table service local storage              
    //      localStorage.removeItem('existSort');
    //      localStorage.removeItem('filtersValue');
    //      localStorage.removeItem('paginate');
    //    }
    //     this.initialLoad = true;
    //   }
    // });
  }
}
